import { render, staticRenderFns } from "./UserSimple.vue?vue&type=template&id=71639423&"
import script from "./UserSimple.vue?vue&type=script&lang=js&"
export * from "./UserSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports